import { goLogin } from '@/api/api'
import { getUserRoleData, getRoleMenuData, getUserMenuData } from '@/api/power'

const user = {
  state: {
    // 用户名
    name: '',
    // 用户角色id
    roles: null,
    // 0->超级管理员；1->用户
    mold: null
  },
  mutations: {
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_MOLD: (state, mold) => {
      state.mold = mold
    }
  },
  actions: {
    // 获取用户角色ID
    GetInfo({ commit }, username) {
      // const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        getUserRoleData(username).then(res => {
          const data = res.data.data
          if (data.length > 0) {
            let roleId = data[0].id
            commit('SET_ROLES', roleId)
            getUserMenuData(username).then(response => {
              console.log('用户菜单', response.data)
              resolve(response)
            })
          } else {
            reject('getInfo: roles must be a non-null array !')
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 退出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        commit('SET_ROLES', null)
        resolve()
      }).catch(err => {
        reject(err)
      })
    }
  }
}

export default user
